<template>
	<section class="clinic_form">
		<div class="clinic_left">
			<div class="field">
				<label for="clinic_field01">Название</label>
				<input type="text" id="clinic_field01" v-model="model.name">
			</div>

			<div class="field">
				<label for="clinic_field011">Владелец</label>
				<select id="clinic_field011" v-model="model.user_id">
					<option v-for="user in users" :value="user._id">{{user.first_name}} {{user.last_name}}</option>
				</select>
			</div>

			<div class="field">
				<label for="clinic_field02">Страна</label>
				<input type="text" id="clinic_field02" v-model="model.country">
			</div>

			<div class="field">
				<label for="clinic_field03">Район</label>
				<input type="text" id="clinic_field03" v-model="model.region">
			</div>

			<div class="field">
				<label for="clinic_field04">Город</label>
				<input type="text" id="clinic_field04" v-model="model.city">
			</div>

			<div class="field">
				<label for="clinic_field05">Область</label>
				<input type="text" id="clinic_field05" v-model="model.area">
			</div>

			<div class="field">
				<label for="clinic_field06">Улица</label>
				<input type="text" id="clinic_field06" v-model="model.street">
			</div>

			<div class="field">
				<label for="clinic_field07">Дом</label>
				<input type="text" id="clinic_field07" v-model="model.house">
			</div>

			<div class="field">
				<label for="clinic_field08">Квартира</label>
				<input type="text" id="clinic_field08" v-model="model.apartment">
			</div>

			<div class="field">
				<label for="clinic_field09">Метро</label>
				<input type="text" id="clinic_field09" v-model="model.metro">
			</div>

			<div class="field">
				<label for="clinic_field10">Краткое описание</label>
				<input type="text" id="clinic_field10" v-model="model.description_little">
			</div>

			<div class="field">
				<label for="clinic_field11">Широта</label>
				<input type="text" id="clinic_field11" v-model="model.latitude">
			</div>

			<div class="field">
				<label for="clinic_field12">Долгота</label>
				<input type="text" id="clinic_field12" v-model="model.longitude">
			</div>

			<div class="field">
				<label for="clinic_field13">Тип</label>
				<select id="clinic_field13" v-model="model.own_type">
					<option value="state">Государственная</option>
					<option value="private">Частная</option>
				</select>
			</div>

			<div class="field">
				<label for="clinic_field15">Тип</label>
				<select id="clinic_field15" v-model="model.clinic_type_id">
					<option v-for="type in clinicTypes" :value="type._id">{{type.name}}</option>
				</select>
			</div>

			<div class="field">
				<label for="clinic_field14">Статус</label>
				<select id="clinic_field14" v-model="model.status">
					<option value="verified">Верифицированая</option>
					<option value="not_verified">Не верифицированая</option>
				</select>
			</div>
		</div>

		<div class="clinic_right">
			<vue-editor v-model="model.description"></vue-editor>
		</div>
	</section>
</template>

<script>
	import {VueEditor} from 'vue2-editor'

	export default {
		name: "ClinicForm",
		props: ['model'],
		components: {
			'vue-editor': VueEditor
		},
		data() {
			return {
				users: [],
				clinicTypes: []
			}
		},
		mounted() {
			this.$store.dispatch('user/list', {per_page: 1000}).then(res => {
				this.users = res.data
			})
			this.$store.dispatch('clinicType/all').then(list => {
				this.clinicTypes = list
			})
		}
	}
</script>



// WEBPACK FOOTER //
// ClinicForm.vue?4ad691f7